// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"346":"a28806a0","831":"976aae30"}[chunkId] + ".chunk.css");